export default "__VITE_ASSET__qzbrhCmd__"